import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { getReportingSnapshot, getReportSupportCreatedCount } from '../../services/reportingService';
import { clearUser } from './userSlice';

export const fetchReportingSnapshot = createAsyncThunk(
  'reporting/fetchSnapshot',
  async (_, { signal, rejectWithValue }) => {
    try { return await getReportingSnapshot({ signal }); }
    catch (error) { return rejectWithValue(error.message || 'Unable to load reports.'); }
  },
);

export const reportingRangeKey = (range) => `${range.startAt}|${range.endAtExclusive}`;
export const fetchReportingSupportCount = createAsyncThunk(
  'reporting/fetchSupportCount',
  async (range, { rejectWithValue }) => {
    try { return { value: await getReportSupportCreatedCount(range), rangeKey: reportingRangeKey(range) }; }
    catch (error) { return rejectWithValue(error.message || 'Support ticket counts could not be loaded.'); }
  },
);

const initialState = {
  snapshot: null,
  loading: false,
  error: null,
  requestId: null,
  support: { value: null, rangeKey: null, loading: false, error: null, requestId: null },
};

const reportingSlice = createSlice({
  name: 'reporting',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(clearUser, () => initialState)
      .addCase(fetchReportingSnapshot.pending, (state, action) => {
        state.loading = true;
        state.error = null;
        state.requestId = action.meta.requestId;
      })
      .addCase(fetchReportingSnapshot.fulfilled, (state, action) => {
        if (state.requestId !== action.meta.requestId) return;
        state.loading = false;
        state.snapshot = action.payload;
      })
      .addCase(fetchReportingSnapshot.rejected, (state, action) => {
        if (state.requestId !== action.meta.requestId) return;
        state.loading = false;
        if (!action.meta.aborted) state.error = action.payload || action.error.message;
      })
      .addCase(fetchReportingSupportCount.pending, (state, action) => {
        state.support = { value: null, rangeKey: reportingRangeKey(action.meta.arg), loading: true, error: null, requestId: action.meta.requestId };
      })
      .addCase(fetchReportingSupportCount.fulfilled, (state, action) => {
        if (state.support.requestId !== action.meta.requestId) return;
        state.support.loading = false;
        state.support.value = action.payload.value;
      })
      .addCase(fetchReportingSupportCount.rejected, (state, action) => {
        if (state.support.requestId !== action.meta.requestId) return;
        state.support.loading = false;
        if (!action.meta.aborted) state.support.error = action.payload || action.error.message;
      });
  },
});

export const selectReporting = (state) => state.reporting;
export default reportingSlice.reducer;
